import React, {ReactNode} from 'react';
import InputNumber from "../InputNumber";
import {Input, Select as SelectAntd} from "antd";
import styles from './style.module.scss';
import {notify} from "../../../util/varibles/message";
import {IErrorForm} from "../../../util/varibles/interface";

interface IFormProps {
    className?: string,
    label?: string
    hideLabel?: boolean
    error?: IErrorForm
    require?: boolean
    loading?: boolean
    children?: ReactNode
}

const FormItem: React.FC<IFormProps> = ({className, require, label, hideLabel, children, error = {}}) => {
    return <div className={[styles.box, className].join(' ')}>
        {!hideLabel && <div className={styles.label} data-lev='label' data-require={require}>{label}</div>}
        {children}
        <div className={styles.error} data-lev='error' data-show={Object.keys(error).length > 0}>
            {Object.keys(error).map(key => notify[error[key]]([label]))}
        </div>
    </div>;
};

export const Number: React.FC<{
    inputClassName?: string,
    placeholder?: string
    value?: any
    suffix?: string | ReactNode
    onChange?(value: any): void,
    onBlur?(): void
} & IFormProps> = (props) => {
    const {inputClassName = "", placeholder, value, suffix, onChange, onBlur, ...otherProps} = props;
    return <FormItem  {...otherProps}>
        <InputNumber
            className={[styles.input, inputClassName].join(' ')}
            placeholder={placeholder}
            value={value}
            suffix={suffix}
            onChange={onChange}
            onBlur={onBlur}
        />
    </FormItem>
}

export const Text: React.FC<{
    inputClassName?: string,
    placeholder?: string
    value?: any
    suffix?: string | ReactNode
    onChange?(value: any): void,
    onBlur?(): void
} & IFormProps> = (props) => {
    const {inputClassName = 'h-[32px]', placeholder, value, suffix, onChange, onBlur, ...otherProps} = props;
    return <FormItem  {...otherProps}>
        <Input
            className={inputClassName}
            placeholder={placeholder}
            value={value}
            suffix={suffix}
            onChange={({target}) => onChange?.(target.value || '')}
            onBlur={onBlur}
        />
    </FormItem>
}

interface IOpt {
    label: string | ReactNode
    value: any
    root: any
}

export const Select: React.FC<{
    inputClassName?: string,
    placeholder?: string
    value?: any
    mode?: 'multiple' | 'tags'
    options?: IOpt[]
    onSelect?(value: any, opt: IOpt): void,
    onDeselect?(value: any, opt: IOpt): void,
    onChange?(value: any): void,
    onBlur?(): void
} & IFormProps> = (props) => {
    const {
        inputClassName = styles.select,
        placeholder,
        value,
        mode,
        options = [],
        onSelect,
        onDeselect,
        onChange,
        onBlur,
        ...otherProps
    } = props
    return <FormItem  {...otherProps}>
        <SelectAntd
            mode={mode}
            className={inputClassName}
            placeholder={placeholder}
            value={value}
            options={options}
            onBlur={onBlur}
            onSelect={onSelect}
            onDeselect={onDeselect}
        />
    </FormItem>
}

export enum FORM_TYPE {
    NUMBER = 'Number',
    TEXT = 'Text',
    SELECT = 'Select',
}

type TFormItem = typeof FormItem
type TInputItem = TFormItem & {
    [FORM_TYPE.NUMBER]: typeof Number,
    [FORM_TYPE.TEXT]: typeof Text,
    [FORM_TYPE.SELECT]: typeof Select
}

const InputForm: TInputItem = Object.assign(FormItem, {
    Number,
    Text,
    Select
});

export default InputForm;